import React from "react"

import imageLoader from '../../assets/images/loader.svg'

const Loader = _ => <span style={{display: "block", textAlign: "center"}}><img src={imageLoader} alt="Carregando" /></span>

export default Loader